// src/hooks/useWebSocketClient.ts
import { useEffect, useCallback } from 'react';
import { useWebSocketClient } from 'renderer/utils';
var CHAR_CODE;
(function (CHAR_CODE) {
    // @ 프린터 초기화
    CHAR_CODE[CHAR_CODE["AT"] = 64] = "AT";
    // ESC 프린터 초기화
    CHAR_CODE[CHAR_CODE["ESC"] = 27] = "ESC";
    // LF 줄바꿈
    CHAR_CODE[CHAR_CODE["LF"] = 10] = "LF";
    // CR 캐리지 리턴
    CHAR_CODE[CHAR_CODE["CR"] = 13] = "CR";
    // HT 수평 탭
    CHAR_CODE[CHAR_CODE["HT"] = 9] = "HT";
    // 프린터 용지 절단 명령어
    CHAR_CODE[CHAR_CODE["I"] = 105] = "I";
})(CHAR_CODE || (CHAR_CODE = {}));
var CAT_WEBSOCKET_URL = 'ws://localhost:1516';
export var useCATWebSocketClient = function (handleMessage) {
    var _a = useWebSocketClient(CAT_WEBSOCKET_URL, handleMessage), client = _a.client, status = _a.status, connect = _a.connect, disconnect = _a.disconnect, sendMessage = _a.sendMessage;
    useEffect(function () {
        if (!client)
            return;
        // getInstance를 통해 클라이언트 생성
        var dataListener = function (ev) {
            if (handleMessage) {
                handleMessage(ev);
            }
        };
        client.addListener('data', dataListener);
        // 컴포넌트 언마운트 시 cleanup: 리스너 제거 및 연결 종료
        return function () {
            client.removeListener('data', dataListener);
        };
    }, [client, handleMessage]);
    var requestPayment = useCallback(function (data) {
        sendMessage({ KIS_ICApproval: data });
    }, [sendMessage]);
    var stopPayment = useCallback(function () {
        sendMessage({ KIS_Agent_Stop: {} });
    }, [sendMessage]);
    var printReceipt = useCallback(function (data, lines) {
        // 한 줄의 길이를 40바이트 기준으로 작성.
        var receipt = '';
        //**************************************************
        // 초기화: ESC @
        //**************************************************
        receipt += String.fromCharCode(CHAR_CODE.ESC);
        receipt += String.fromCharCode(CHAR_CODE.AT);
        // 각 메시지 뒤에 개행 추가
        lines.forEach(function (line) {
            receipt += line + String.fromCharCode(CHAR_CODE.LF);
        });
        //**************************************************
        // 용지 절단: ESC I
        //**************************************************
        receipt += String.fromCharCode(CHAR_CODE.ESC);
        receipt += String.fromCharCode(CHAR_CODE.I);
        sendMessage({
            KIS_ICApproval: {
                inTranCode: 'UC',
                inCatTranGubun: data.inCatTranGubun || 1,
                UnitTimeout: '10',
                inAgentData: receipt
            }
        });
    }, [sendMessage]);
    return { client: client, status: status, connect: connect, disconnect: disconnect, requestPayment: requestPayment, stopPayment: stopPayment, printReceipt: printReceipt };
};
